<template>
  <view class="package-list">
    <view class="unclaimed-area">
      <view class="unclaimed-title">
        <view class="title-text"
          >可用加速包
          <image
            class="question-mark"
            src="https://ut-static.udache.com/webx/sfc/dgBZrKZ4wLfINBE_2mWPH.png"
            bindtap="jumpToPackIntro"
          />:
          <view class="num">{{ ownAmount }}</view>
          <view class="expire" wx:if="{{packageExpire}}">{{packageExpire}}</view>
        </view>
        <view class="unclaimed-btn" bindtap="showPackDetail">
          <view>明细</view>
          <image
            class="right-icon"
            src="https://ut-static.udache.com/webx/sfc/HLWBHmH68xKK0NRgyGJ0m.png"
          />
        </view>
      </view>
      <view wx:if="{{unclaimed?.length}}">
        <packageItem
          isStock
          wx:for="{{unclaimed}}"
          packageItem="{{item}}"
          posterUrl="{{posterUrl}}"
      /></view>
      <view wx:elif="{{!unclaimed?.length && !ownAmount}}" class="empty">未领取任何加速包</view>
    </view>
    <view class="divider" wx:if="{{received?.length}}"/>
    <view wx:if="{{received?.length}}" class="received-area">
      <view class="received-title">
        <text class="title-text">未领取的加速包</text>
        <text class="received-tip">满足使用条件即可使用</text>
      </view>
      <packageItem wx:for="{{received}}" packageItem="{{item}}" posterUrl="{{posterUrl}}" />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { debounce } from '@/utils'
  import { goTo } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'

  createComponent({
    props: {
      bannerFrom: {
        type: String,
        value: ''
      },
    },
    data() {},
    ready() {
      trackEvent('userteam_train_coupon_banner_float_sw', 'UT-火车票-领券组件-浮层-展现', {
        pg_type: this.bannerFrom,
        module: 'speedup'
      })
    },
    computed: {
      ...store.mapState({
        packages_info: 'coupon.couponData.packages_info'
      }),
      unclaimed() {
        return this.packages_info?.stock_infos ?? []
      },
      received() {
        return this.packages_info?.infos ?? []
      },
      ownAmount() {
        return this.packages_info?.amount ?? 0
      },
      packageExpire() {
        return this.packages_info?.package_expire ?? ""
      },
      unclaimedAmount() {
        return (
          this.unclaimed?.reduce((total, item) => total + item?.package_info?.amount ?? 0, 0) ?? 0
        )
      },
      receivedAmount() {
        return this.received?.reduce((total, item) => total + item?.package_info?.amount ?? 0, 0) ?? 0
      },
      posterUrl() {
        return this.packages_info?.share_png ?? ''
      }
    },
    methods: {
      showPackDetail() {
        this.triggerEvent('showPackDetail')
      },
      jumpToPackIntro: debounce(
        function () {
          goTo({ url: 'https://v.didi.cn/Qz1M3zE' })
        },
        300,
        false
      )
    }
  })
</script>

<style scoped lang="stylus">
  .package-list
    overflow-y auto
    .title-text
      display flex
      align-items center
      font-family PingFangSC-Semibold
      font-size 14px
      font-weight 600
      color #333
      .question-mark
        @extend .expand-click
        height 12px
        width 12px
        margin 0 2px
      .num
        font-family Barlow Semi Condensed
        font-size 20px
        font-weight 400
        line-height 24px
        letter-spacing 0px
        color #F86316
        margin-left 10px
        display flex
        margin-top -1.5px
      .expire
        font-family PingFang SC
        font-size 12px
        line-height 12px
        color #999999
        font-weight normal
        margin-left 5px
    .divider
      height 7px
      width 100%
      background #F6F8FB
    .received-area
      background #fff
      padding 20px 18px
      .received-title
        display flex
        align-items center
        padding-bottom 15px
        .received-tip
          font-family PingFangSC-Regular
          font-size 12px
          font-weight 400
          color #999
          margin-left 5px
    .unclaimed-area
      background #fff
      padding 20px 18px
      padding-top 0
      margin-bottom 7px
      .empty
        font-family PingFangSC-Regular
        font-weight 400
        font-size 12px
        line-height 12px
        letter-spacing 0px
        color #999999
        display flex
        justify-content center
        padding-top 45px
      .unclaimed-title
        display flex
        align-items center
        justify-content space-between
        margin-bottom 15px
        .unclaimed-btn
          display flex
          align-items center
          font-family PingFangSC-Regular
          font-weight 400
          font-size 14px
          line-height 14px
          letter-spacing 0px
          color #999
          .right-icon
            height 8px
            width 4.5px
            margin-left 4.5px
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {
        packageItem: './package-item'
      }
    }
</script>